import {styled} from "@mui/styles";

export const StickyHeader = styled("div")(({ theme }) => ({
	position: "sticky",
	top: 0,
	zIndex: 2,
	backgroundColor: theme.palette.background.default,
}));
